import React from 'react';
import ReactDOM from 'react-dom/client';


import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./Redux/store";
import App from "./Components/App/Component/App";
import { storageGet } from "./Libs/Collector/StorageAction";
import { injectStore, getRefreshPageCheckToken } from "./Libs/Api/AxiosConfig"
import { getBrand, applyBrand } from "./Libs/Branding/brands"
import { isGuestSurface } from "./Libs/Auth/guestSurface"


if (process.env.REACT_APP_ENV === 'PROD') console.log = function () {};

// Domaine göre marka (logo + renk) — render'dan önce CSS değişkenlerine yaz.
applyBrand(getBrand());

injectStore(store);

const token = storageGet("token");
const refreshToken = storageGet("refreshToken");

// Gömme yüzeyi (widget iframe'i / storefront) PANEL OTURUMUNA DOKUNMAZ. Aynı origin'de
// çalıştığı için buradaki refresh çağrısı paneldeki refresh token'ı tüketip döndürüyor,
// panelin bir sonraki yenilemesi 401 alıp kullanıcıyı çıkışa atıyordu.
if (!isGuestSurface() && typeof token !== "object" && token !== "" && typeof refreshToken !== "object" && refreshToken !== "") {
  getRefreshPageCheckToken();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
